import React, { useMemo, useState } from 'react';
import Icon from '../../../components/AppIcon';
import { ALL_ICON_NAMES, ICON_CATALOG, normalizeIconName } from '../utils/iconCatalog';

const inputClass =
  'w-full rounded-lg border border-border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring';

export default function IconPickerField({ value, onChange, previewColor = '#2563eb', previewSize = 32 }) {
  const [query, setQuery] = useState('');
  const selected = normalizeIconName(value);

  const filteredGroups = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return ICON_CATALOG;

    const names = ALL_ICON_NAMES.filter((name) => name.toLowerCase().includes(q));
    if (!names.length) return [];

    return [{ id: 'search', label: 'Résultats', icons: names }];
  }, [query]);

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-3 rounded-xl border border-border bg-muted/20 p-3">
        <div
          className="w-14 h-14 rounded-xl border border-border bg-card flex items-center justify-center shrink-0"
          style={{ color: previewColor }}
        >
          <Icon name={selected} size={Math.min(previewSize, 40)} color="currentColor" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium text-foreground">{selected}</div>
          <div className="text-xs text-muted-foreground mt-0.5">Icône sélectionnée</div>
        </div>
      </div>

      <input
        className={inputClass}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Rechercher une icône…"
      />

      <div className="max-h-56 overflow-y-auto rounded-xl border border-border p-2 space-y-3">
        {filteredGroups.length === 0 ? (
          <p className="text-sm text-muted-foreground text-center py-6">Aucune icône trouvée</p>
        ) : (
          filteredGroups.map((group) => (
            <div key={group.id}>
              <div className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground px-1 mb-1.5">
                {group.label}
              </div>
              <div className="grid grid-cols-6 sm:grid-cols-8 gap-1">
                {group.icons.map((name) => {
                  const active = name === selected;
                  return (
                    <button
                      key={name}
                      type="button"
                      title={name}
                      onClick={() => onChange(name)}
                      className={`aspect-square rounded-lg flex items-center justify-center transition-smooth ${
                        active
                          ? 'bg-primary text-primary-foreground ring-2 ring-primary ring-offset-1 ring-offset-background'
                          : 'hover:bg-muted text-foreground'
                      }`}
                    >
                      <Icon name={name} size={18} color="currentColor" />
                    </button>
                  );
                })}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
